// Components
import Page from '@/common-utils/components/structure/page/Page';
import NewsLetterContent from '@/app/modules/newsletters/NewsLetterContent';
// Common
import RouteUrls from '../enums/RouteUrls';

/**
 * @returns {JSX.Element} NewsLetter
 */
function NewsLetter() {

    return (
        <Page>
            <Page.Header
                route={RouteUrls.NEWSLETTER}
                routeBase={RouteUrls.NEWSLETTER}
            />
            <Page.Body dataCy='page-newsletter'>
                <NewsLetterContent />
            </Page.Body>
        </Page>
    );
}

export default NewsLetter;